// Auto-generated blur placeholders keyed by ImageSlot id
export const blurPlaceholders: Record<string, string> = {
  "dashboard-mockup": "data:image/webp;base64,UklGRi4AAABXRUJQVlA4ICIAAACwAQCdASoQAAkABUB8JZwAAud/gsPwAP7tVkYZZMa8CAAA",
  "dashboard-floating-chart": "data:image/webp;base64,UklGRiYAAABXRUJQVlA4IBoAAAAwAQCdASoQAAkABUB8JaQAA3AA/u/0fQAAAA==",
  "dashboard-floating-compare":
    "data:image/webp;base64,UklGRiYAAABXRUJQVlA4IBoAAAAwAQCdASoQAAkABUB8JZwAA3AA/u/UskAAAA==",
  "cta-illustration":
    "data:image/webp;base64,UklGRjQAAABXRUJQVlA4ICgAAACwAQCdASoQAAkABUB8JQBOgB6Q/0uAAP7czMHhrWNQec9rXKyBPgAA",
  "uzbekistan-map": "data:image/webp;base64,UklGRigAAABXRUJQVlA4IBwAAAAwAQCdASoQAAkABUB8JZQAA3AA/u+OPydq8XAA",
  "feature-price-compare":
    "data:image/webp;base64,UklGRioAAABXRUJQVlA4IB4AAAAwAQCdASoQAAkABUB8JZwAA3AA/u7IKlJqtsmAAAA=",
  "feature-trends": "data:image/webp;base64,UklGRioAAABXRUJQVlA4IB4AAAAwAQCdASoQAAkABUB8JZwAA3AA/u9JjDTpW4oAAAA=",
  "feature-coverage": "data:image/webp;base64,UklGRigAAABXRUJQVlA4IBwAAAAwAQCdASoQAAkABUB8JZwAA3AA/u/S0tb0IAAA",
  "feature-realtime": "data:image/webp;base64,UklGRiwAAABXRUJQVlA4ICAAAAAwAQCdASoQAAkABUB8JZwAA3AA/u47FX6EFilwmpgAAA==",
  "how-collect": "data:image/webp;base64,UklGRjAAAABXRUJQVlA4ICQAAADQAQCdASoQAAkABUB8JQBdgCIfIp8wAAD+7XhqAiwl9w+kEAA=",
  "how-process": "data:image/webp;base64,UklGRiwAAABXRUJQVlA4ICAAAAAwAQCdASoQAAkABUB8JQAAhnAA/uxk9O80lxdUcpx0AA==",
  "how-decide": "data:image/webp;base64,UklGRjAAAABXRUJQVlA4ICQAAADQAQCdASoQAAkABUB8JQBYdiHYN/RaAAD+w0SpcBj6mQ8DAAA=",
  "hero-3d": "data:image/webp;base64,UklGRioAAABXRUJQVlA4IB4AAABQAQCdASoQAAkABUB8JZQABDOAAP7vkOXh6VaWYAA=",
  "problem-before":
    "data:image/webp;base64,UklGRjAAAABXRUJQVlA4ICQAAABwAQCdASoQAAkABUB8JZQAApno5AD+w/kvaLHQsCN71SHAAAA=",
  "problem-after":
    "data:image/webp;base64,UklGRjAAAABXRUJQVlA4ICQAAACwAQCdASoQAAkABUB8JYwCw7EOtW9oAP7DRoNwc4fDjK385AA=",
};
